module.exports = __webpack_public_path__ + "img/nc.5170c1e6.png";